var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.o)?_c('div',{staticClass:"toast flex-col",class:{icon: _vm.o.icon},on:{"click":function($event){_vm.o=null}}},[(_vm.o.icon)?_c('i',{staticClass:"icon-yike",class:[("icon-" + (_vm.o.icon))]}):_vm._e(),_vm._v(" "),(_vm.o.text)?_c('span',{staticClass:"hint"},[_vm._v(_vm._s(_vm.o.text))]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f8571a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toast.vue
// module id = null
// module chunks = 